import * as uuid from 'uuid';
import actions from './actions';
import { createReducer } from '../../../../../helpers/reducer';
import { keyBy } from '../../../../../helpers/core';

const initState = {
  loading: false,
  companyPricingAgreements: [],
  editForm: [],
  formInfo: {},
};

const getInitialRuleData = formInfo => ({
  custom_id: uuid.v4(),
  kind: formInfo.kinds?.[0]?.id,
  units: formInfo.units?.[0]?.id,
  amount: 0,
  district_ids: [],
  all_districts: false,
});

function validate(/* attr, value */) {
  return '';
}

function onCreate(state) {
  const newRule = getInitialRuleData(state.formInfo);
  const propsArray = Object.keys(newRule);
  const newItem = keyBy(
    propsArray,
    prop => prop,
    prop => ({
      name: prop,
      value: newRule[prop],
      error: validate(prop, newRule[prop]),
      touched: false,
    }),
  );

  return {
    ...state,
    loading: true,
    editForm: [newItem],
  };
}

function onEdit(state) {
  return {
    ...state,
    loading: true,
  };
}

function onLoadRequest(state) {
  return {
    ...state,
    loading: true,
  };
}

function onLoadSuccess(state, { payload }) {
  return {
    ...state,
    companyPricingAgreements: payload.data.records,
    loading: false,
  };
}

function onLoadCompanyPricingAgreementsDataSuccess(state, { payload }) {
  const { data } = payload;

  const editForm = [];

  data.records.forEach(record => {
    if (record.districts) {
      record.district_ids = record.districts.map(item => item.id);
    }
    record.custom_id = uuid.v4();
    delete record.districts;
  });

  data.records.forEach((record, index) => {
    const propsArray = Object.keys(record);
    editForm[index] = keyBy(
      propsArray,
      prop => prop,
      prop => {
        return {
          name: prop,
          value:
            record[prop] && Object.prototype.hasOwnProperty.call(record[prop], 'id') ? record[prop].id : record[prop],
          error: validate(prop, record[prop]),
          touched: false,
        };
      },
    );
  });

  return {
    ...state,
    editForm,
  };
}

function onLoadFormDataSuccess(state, { payload }) {
  const { data: formInfo } = payload;

  return { ...state, formInfo: { ...formInfo }, loading: false };
}

function onTouch(state, { payload }) {
  const propsArray = Object.entries(payload.editForm);
  const editForm = keyBy(
    propsArray,
    entry => entry[0],
    entry => {
      const [, value] = entry;

      return {
        ...value,
        touched: true,
      };
    },
  );

  return {
    ...state,
    editForm,
  };
}

function onChangeProperty(state, { payload }) {
  const { attr, value, custom_id } = payload;

  const editForm = [...state.editForm];
  const index = editForm.findIndex(item => item.custom_id.value === custom_id);

  editForm[index][attr] = {
    value,
    error: validate(attr, value),
    name: attr,
    touched: true,
  };

  return {
    ...state,
    editForm,
    baseError: null,
  };
}

function onAddRule(state) {
  const { editForm } = state;

  const newRule = getInitialRuleData(state.formInfo);

  const propsArray = Object.keys(newRule);
  const newFormattedRule = keyBy(
    propsArray,
    prop => prop,
    prop => {
      return {
        name: prop,
        value: newRule[prop],
        error: '',
        touched: false,
      };
    },
  );

  return {
    ...state,
    editForm: [...editForm, newFormattedRule],
  };
}

function onClearStore() {
  return { ...initState };
}

export default createReducer(initState, {
  [actions.ADD_RULE]: onAddRule,
  [actions.CHANGE_PROPERTY]: onChangeProperty,
  [actions.CLEAR_STORE]: onClearStore,
  [actions.CREATE]: onCreate,
  [actions.EDIT]: onEdit,
  [actions.LOAD_COMPANY_PRICING_AGREEMENTS_DATA_SUCCESS]: onLoadCompanyPricingAgreementsDataSuccess,
  [actions.LOAD_FORM_DATA_SUCCESS]: onLoadFormDataSuccess,
  [actions.LOAD_REQUEST]: onLoadRequest,
  [actions.LOAD_SUCCESS]: onLoadSuccess,
  [actions.TOUCH]: onTouch,
});
